import script from "./ChatShell.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatShell.vue?vue&type=script&setup=true&lang=js"

import "./ChatShell.vue?vue&type=style&index=0&id=d704d35a&lang=css"

const __exports__ = script;

export default __exports__